import React from 'react';
import PageCard from 'features/shared/components/card/PageCard';
import PaymentMethodDTO from 'features/payments/dtos/PaymentMethodDTO';
import { Currency } from 'features/shared/enums/currency';
import InfoItem from 'features/shared/components/infoItem/InfoItem';
import { PaymentCategory } from '../enums/paymentCategory';
import PaymentMethod from './PaymentMethod';
import { useTranslation } from 'react-i18next';
import ContactPersonDTO from 'features/contractualAccounts/dtos/ContactPersonDTO';
import { isEmptyOrUndf } from 'features/shared/helpers/objects';
import ContactPerson from 'features/contractualAccounts/components/ContactPerson';
import RenderWrapper from 'features/shared/components/renderWrapper/RenderWrapper';

interface Props {
  paymentMethods: PaymentMethodDTO[];
  currency: Currency;
  contactPerson?: ContactPersonDTO;
  enabledAdvanceInvoicing?: boolean;
}

const PaymentMethodCard = ({paymentMethods, currency, contactPerson, enabledAdvanceInvoicing = true }: Props) => {
  // tanslations
  const { t } = useTranslation(["payments\\enums\\paymentCategory"]);
  const tLabels = useTranslation("payments\\payments").t;

  // helpers
  const getItemWrapperClass = () => {
    let interestRate = paymentMethods[0] ? paymentMethods[0].interestRate : null;

    if (!isEmptyOrUndf(contactPerson) || interestRate) {
      return "col-sm-6 col-lg-4 col-xl-3 px-sm-3 pb-2";
    }

    return "col-sm-6 col-lg-4 px-sm-3 pb-2";
  }

  // sub-renders
  const renderPaymentMethod = (paymentCategory: PaymentCategory) => {
    let method = paymentMethods.find(x => x.paymentCategory == paymentCategory);
    if (method) {
      return <PaymentMethod paymentMethod={method} />;
    }
  }

  const renderPerson = () => {
    return <ContactPerson person={contactPerson!} />;
  }

  const renderCotnactPerson = () => {
    if (!isEmptyOrUndf(contactPerson)) {
      return (
        <div className={getItemWrapperClass()}>
          <InfoItem title={tLabels("paymentMethodCard.contactPerson")} value={renderPerson()} /> 
        </div>
      );
    }    
  }

  const renderInterestRate = () => { 
    let interestRate = paymentMethods[0] ? paymentMethods[0].interestRate : null;

    if (interestRate) {
      return (
        <div className={getItemWrapperClass()}>
          <InfoItem title={tLabels("paymentMethodCard.interestRate")} value={interestRate} /> 
        </div>
      );
    }
  }

  // render
  return (
    <PageCard title={`${tLabels("paymentMethodCard.title")}`} subtitle={`(${currency})`}>
      <div className="row no-gutters">
        <div className={getItemWrapperClass()}>
          <InfoItem title={t(PaymentCategory.Invoicing)} value={renderPaymentMethod(PaymentCategory.Invoicing)} />
        </div>
        <RenderWrapper isVisible={() => enabledAdvanceInvoicing}>
          <div className={getItemWrapperClass()}>
            <InfoItem title={t(PaymentCategory.AdvanceInvoicing)} value={renderPaymentMethod(PaymentCategory.AdvanceInvoicing)}  />
          </div>
        </RenderWrapper>
        <div className={getItemWrapperClass()}>
          <InfoItem title={t(PaymentCategory.Overpayments)} value={renderPaymentMethod(PaymentCategory.Overpayments)}   />
        </div>
        {renderInterestRate()}
        {renderCotnactPerson()}
      </div>
    </PageCard>
  )
}

export default PaymentMethodCard;
